module.exports = __webpack_public_path__ + "static/img/78.723e3f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/23/78.jpg
// module id = 742
// module chunks = 0